import React, { PropsWithChildren } from "react";
import { useState } from "react";
import { InputFL, InputFLProps } from "./InputFL";
import * as Icons from "Components/Icons";
import { FieldValues } from "react-hook-form";

export const PasswordInputFL = <T extends FieldValues,>({ children, type, ...rest }: PropsWithChildren<InputFLProps<T>>) => {
   const [isPasswordVisible, setIsPasswordVisible] = useState(false);
   const togglePasswordVisible = () => {
      setIsPasswordVisible((wasVisible) => !wasVisible);
   }
   return (
      <InputFL type={isPasswordVisible ? "text" : "password"} {...rest}>
         {isPasswordVisible ? <Icons.Visibility className="tc-icon-active" onClick={togglePasswordVisible} /> : <Icons.VisibilityOff className="tc-icon-active" onClick={togglePasswordVisible} />}
      </InputFL>
   );
}